import React from 'react';
import {
    CardBlock
} from 'reactstrap';
import AviCollectLoader from "../../../src/views/pages/assets/avicollect.gif";

const PageLoading = () => (
    <div>
        <CardBlock className="table-responsive" id="loading-view">
            <div className="row">
                <h6 className="mb-4 col-md-8 text-uppercase pull-left">&nbsp;</h6>

            </div>
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div style={{textAlign : 'center'}}>
                            <img src={AviCollectLoader} height="80px" alt="AviCollect Loader"/>
                        </div>
                        <h5 className="text-center mt-1">
                            Fetching data...
                        </h5>
                        {/*<div className="sk-cube-grid">
                            <div className="sk-cube sk-cube1"></div>
                            <div className="sk-cube sk-cube2"></div>
                            <div className="sk-cube sk-cube3"></div>
                            <div className="sk-cube sk-cube4"></div>
                            <div className="sk-cube sk-cube5"></div>
                            <div className="sk-cube sk-cube6"></div>
                            <div className="sk-cube sk-cube7"></div>
                            <div className="sk-cube sk-cube8"></div>
                            <div className="sk-cube sk-cube9"></div>
                        </div>*/}
                    </div>
                </div>
            </div>
        </CardBlock>
    </div>
);

export default PageLoading;



// WEBPACK FOOTER //
// ./src/views/utils/page.loading.js